import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// @ts-ignore
// tslint:disable-next-line:no-submodule-imports
import { lodashUtil } from '@antv/l7-utils';
import DOM from "../../utils/dom";
import { Event } from "./event";
const {
  merge
} = lodashUtil;
export default class MapMouseEvent extends Event {
  /**
   * @private
   */
  constructor(type, map, originalEvent, data = {}) {
    const point = DOM.mousePos(map.getCanvasContainer(), originalEvent);
    const lngLat = map.unproject(point);
    super(type, merge({
      point,
      lngLat,
      originalEvent
    }, data));
    /**
     * `true` if `preventDefault` has been called.
     * @private
     */
    /**
     * The `Map` object that fired the event.
     */
    _defineProperty(this, "target", void 0);
    /**
     * The DOM event which caused the map event.
     */
    _defineProperty(this, "originalEvent", void 0);
    /**
     * The pixel coordinates of the mouse cursor, relative to the map and measured from the top left corner.
     */
    _defineProperty(this, "point", void 0);
    /**
     * The geographic location on the map of the mouse cursor.
     */
    _defineProperty(this, "lngLat", void 0);
    _defineProperty(this, "defaultPrevented", void 0);
    this.defaultPrevented = false;
    this.target = map;
  }
  preventDefault() {
    this.defaultPrevented = true;
  }
}